import initialstate from '../../initialstate';
import {HttpStatusCodes} from '../../../util/uiconstants';
import {GET_GROUP_SNAPSHOT_BY_ID, CLEAN_GROUP_SNAPSHOT} from '../../../actions/actiontypes';
import normalizeGroupSnapshot from './normalizeGroupSnapshot';

export default function groupSnapshotReducer(state = initialstate.groupAudit.groupSnapshots, action) {
	switch (action.type) {
		case GET_GROUP_SNAPSHOT_BY_ID: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const item = normalizeGroupSnapshot(action?.response);
				const groupSnapshots = state?.filter((s) => s.componentId !== item.componentId);
				return [...groupSnapshots, item];
			}
			return state;
		}
		case CLEAN_GROUP_SNAPSHOT: {
			return initialstate.groupAudit.groupSnapshots;
		}
		default:
			return state;
	}
}
